import { createContext, useState } from 'react';

import LscBoardMemberData from './LscBoardMemberData';

export const LscBoardMemberContext = createContext();

const LscBoardMemberContextProvider = ({ children }) => {
  const stateHook = useState(LscBoardMemberData.INITIAL_LSC_BOARD_MEMBER_STATE);

  return (
    <LscBoardMemberContext.Provider value={stateHook}>
      {children}
    </LscBoardMemberContext.Provider>
  );
};

export default LscBoardMemberContextProvider;